import * as React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { cn } from '@/lib/utils';
import { fadeVariants } from '@/lib/motion';

type LoadingOverlayProps = {
  loading: boolean;
  className?: string;
  label?: string;
};

export default function LoadingOverlay({
  loading,
  className,
  label = 'Loading content',
}: LoadingOverlayProps) {
  return (
    <AnimatePresence initial={false}>
      {loading ? (
        <motion.div
          className={cn(
            'pointer-events-none absolute inset-0 z-10 flex flex-col justify-start gap-4 rounded-[inherit] bg-background/72 p-4 backdrop-blur-[1px]',
            className
          )}
          variants={fadeVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          aria-live="polite"
          aria-label={label}
        >
          <div className="flex animate-pulse items-center gap-3">
            <div className="h-8 w-8 rounded-xl bg-muted/70" />
            <div className="flex-1 space-y-2">
              <div className="h-3 w-32 rounded-full bg-muted/75" />
              <div className="h-3 w-20 rounded-full bg-muted/55" />
            </div>
          </div>
          <div className="grid gap-3">
            <div className="h-16 animate-pulse rounded-2xl bg-muted/60" />
            <div className="h-16 animate-pulse rounded-2xl bg-muted/50" />
            <div className="h-16 animate-pulse rounded-2xl bg-muted/40" />
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
